import type { OvpClient } from '@bldsoft/cappie/api/ovp'
import type {
  WebCarouselFindListOutputDto,
  WebCarouselFindOneOutputDto,
  WebContentFindListResponseOutputDto,
} from '@bldsoft/ovp-api-types'
import type { API } from '@setplex/tria-api'
import type { AdapterDefaults } from '../../index.h'
import { payload } from '../../result'
import { format as formatContent } from '../content/format'
import { format } from './format'

export function use(
  client: OvpClient,
  carousels: API['carousels'],
  _api: API,
  _defaults: AdapterDefaults
): void {
  // GET /api/web/carousels
  carousels.base.getManyFx.use(async ({ order }) => {
    const data = payload<WebCarouselFindListOutputDto[]>(
      await client.get.api.web.carousels({ query: { sortOrder: order } })
    )

    if (!data) {
      throw new Error('Empty answer in carousels.base.getManyFx')
    }

    return [...(data || [])].map(format)
  })

  // GET /api/web/carousels/{id}
  carousels.base.getOneFx.use(async ({ id }) => {
    const data = payload<WebCarouselFindOneOutputDto>(
      await client.get.api.web.carousels(id)()
    )

    if (!data) {
      throw new Error('Empty answer in carousels.base.getOneFx')
    }

    return format(data)
  })

  // GET /api/web/carousels/{id}/items
  carousels.base.getItemsFx.use(async ({ id, limit, offset }) => {
    const data = payload<WebContentFindListResponseOutputDto>(
      await client.get.api.web.carousels(id).items({ query: { limit, offset } })
    )

    if (!data) {
      throw new Error('Empty answer in carousels.base.getItemsFx')
    }

    return [...(data.results || [])].map(formatContent)
  })
}
